import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';

declare var $:any;

@Component({
  selector: 'app-lockscreen',
  templateUrl: './lockscreen.component.html',
})
export class LockscreenComponent implements OnInit, AfterViewInit, OnDestroy {

  constructor() { }

  ngOnInit() {
    $('body').addClass('empty-layout');
  }

  ngAfterViewInit() {
    $('#lock-form').validate({
        errorClass: "help-block",
        rules: {
            password: {
                required: true
            }
        },
        highlight: function(e) {
            $(e).closest(".form-group").addClass("has-error")
        },
        unhighlight: function(e) {
            $(e).closest(".form-group").removeClass("has-error")
        },
        errorPlacement: function(e, r) {
            var i = $(r).parents(".input-group, .check-list");
            i.length ? i.after(e) : r.after(e)
        },
    });
  }

  ngOnDestroy() {
    $('body').removeClass('empty-layout');
  }

}
